import React, { Component } from 'react';
import { connect } from 'react-redux';
import { usersUtil, TYPES } from 'services/utils/users-util';
import Date from 'components/shared/text/Date';
import {
  changeQuotesTableFilterSuccess,
  loadTaskForQuoteDetail,
  selectQuotesTableRadio,
} from 'actions/admin/work-orders/details/details';
import {
  getBudget,
  getProposals,
  getQuotes,
  getQuotesSelectedByTaskId,
  getQuotesTableSelectedFilter,
} from 'selectors/admin/work-orders/details/details';
import QuotesTable from './quotes/QuotesTable';
import {
  loadEmailProposalDataRequest,
  showProposalModal,
} from 'actions/admin/work-orders/details/proposal';
import ProposalModal from './proposals/ProposalModal';
import ProposalsTable from './proposals/ProposalsTable';
import Number from 'components/shared/text/Number';
import numeral from 'numeral';
import { selectProposal } from 'actions/admin/work-orders/details/proposal-approval';
import './DetailsQuotes.css';
import {
  getCurrentWorkOrder,
  getTasks,
} from 'selectors/admin/work-orders/work-orders';
import QuoteDetailsModalContainer from './quotes/QuoteDetailsModalContainer';
import { getProposalShow } from 'selectors/admin/work-orders/details/proposal';
import {
  clearQualificationsSelected,
  loadDefaultQualificationsRequest,
} from 'actions/admin/work-orders/details/qualifications';
import { getFirstDate, getLastDate } from 'services/utils/date-util';
import { ProposalStatus } from 'domain/proposal-status-enum';
import { TaskStatusKeys } from 'domain/task-status-enum';
import { getCurrentUser } from 'selectors/authentication';
import { PermissionsUtil } from 'services/utils/permissions-util';
import { getChangeOrderTasks } from 'components/admin/work-orders/details/change-order-tasks/store/selectors';
import {
  showChangeOrderModal,
  selectChangeOrder,
  loadEmailChangeOrderDataRequest,
} from 'components/admin/work-orders/details/change-orders/store/actions';
import ChangeOrderModal from 'components/admin/work-orders/details/change-orders/ChangeOrderModal';
import { getShowChangeOrderModal } from 'components/admin/work-orders/details/change-orders/store/selectors';
import { getChangeOrders } from 'components/admin/work-orders/details/change-orders/store/selectors';
import ChangeOrderQuoteDetailsModalContainer from 'components/admin/work-orders/details/change-order-quotes/ChangeOrderQuoteDetailsModalContainer';
import {
  selectChangeOrderQuote,
  moveToAcr,
} from 'components/admin/work-orders/details/change-order-quotes/store/actions';
import ConfirmationModal from 'components/shared/modal/ConfirmationModal';

class DetailsQuotes extends Component {
  constructor(props) {
    super(props);
    this.userIsClient = usersUtil.hasType(this.props.currentUser, TYPES.CLIENT);
    this.state = { showMoveToAcrConfirmation: false };
  }

  handleQuotesFilter = (filter) => {
    this.props.dispatch(changeQuotesTableFilterSuccess(filter));
  };

  handleQuotesTableRadioSelect = (taskId, quoteId) => {
    this.props.dispatch(selectQuotesTableRadio(taskId, quoteId));
  };

  handleCreateProposalClick = (event) => {
    event.preventDefault();

    const quoteEstimateByQuoteId = {};
    const startDates = [];
    const completionDates = [];
    Object.values(this.props.quotesSelectedByTaskId).forEach((quoteId) => {
      const quote = this.props.quotes.find((element) => element.id === quoteId);
      startDates.push(quote.start_date);
      completionDates.push(quote.end_date);
      quoteEstimateByQuoteId[quoteId] =
        numeral(quote.estimate).value() + numeral(quote.value).value();
    });

    // Clear qualifications data before showing the proposal modal
    this.props.dispatch(clearQualificationsSelected());
    this.props.dispatch(loadDefaultQualificationsRequest()).then((response) => {
      if (response.ok) {
        this.props.dispatch(
          showProposalModal(
            quoteEstimateByQuoteId,
            getFirstDate(startDates),
            getLastDate(completionDates)
          )
        );
      }
    });
  };

  handleProposalSelection = (proposalId) => {
    const proposal = this.props.proposals.find(
      (prop) => prop.id === proposalId
    );
    this.props
      .dispatch(
        loadEmailProposalDataRequest(
          proposal.number,
          this.props.currentWorkOrder.number,
          this.props.currentWorkOrder.name,
          this.props.currentWorkOrder.building.location,
          this.props.currentWorkOrder.client.id,
          this.props.currentWorkOrder.client.company_name
        )
      )
      .then((response) => {
        if (response.ok) {
          this.props.dispatch(selectProposal(proposal));
        }
      });
  };

  handleChangeOrderSelection = (coId) => {
    const changeOrder = this.props.changeOrders.find(
      (co) => co.id.toString() === coId
    );
    this.props
      .dispatch(
        loadEmailChangeOrderDataRequest(
          changeOrder.number,
          this.props.currentWorkOrder.number,
          this.props.currentWorkOrder.name,
          this.props.currentWorkOrder.building.location,
          this.props.currentWorkOrder.client.id
        )
      )
      .then((response) => {
        if (response.ok) {
          this.props.dispatch(selectChangeOrder(changeOrder));
        }
      });
  };

  handleCreateChangeOrderClick = (event) => {
    event.preventDefault();

    // Clear qualifications data before showing the change order modal
    this.props.dispatch(clearQualificationsSelected());
    this.props.dispatch(loadDefaultQualificationsRequest()).then((response) => {
      if (response.ok) {
        this.props.dispatch(
          showChangeOrderModal(
            this.props.quotesSelectedByTaskId,
            this.props.changeOrderTasks
          )
        );
      }
    });
  };

  handleRowSelect = (quoteId) => {
    const quote = this.props.quotes.find((element) => element.id === quoteId);
    this.props.dispatch(loadTaskForQuoteDetail(quote.task.id, quoteId));
  };

  handleChangeOrderRowSelect = (changeOrderTaskId) => {
    const changeOrderTask = this.props.changeOrderTasks.find(
      (cot) => cot.id.toString() === changeOrderTaskId
    );
    this.props.dispatch(selectChangeOrderQuote(changeOrderTask.id));
  };

  handleMoveToAcrClick = () => {
    this.setState({
      showMoveToAcrConfirmation: true,
    });
  };

  handleMoveToAcrConfirmation = (response) => {
    this.setState({
      showMoveToAcrConfirmation: false,
    });
    if (response) {
      this.props.dispatch(
        moveToAcr(
          this.props.currentWorkOrder.id,
          Object.values(this.props.quotesSelectedByTaskId)
        )
      );
    }
  };

  render() {
    const proposalOnWaiting =
      this.props.proposals.filter((proposal) =>
        ProposalStatus.WAITING.equals(proposal.status)
      ).length > 0;
    const proposalOnApproved =
      this.props.proposals.filter((proposal) =>
        ProposalStatus.APPROVED.equals(proposal.status)
      ).length > 0;
    const changeOrderOnWaiting =
      this.props.changeOrders.filter((co) => co.status === 'waiting').length >
      0;
    let budgetTasksByTaskId = {};
    if (this.props.budget !== null) {
      budgetTasksByTaskId = this.props.budget.budget_tasks.reduce(
        (accumulator, currentBudgetTask) => {
          accumulator[currentBudgetTask.task_id] = currentBudgetTask;
          return accumulator;
        },
        {}
      );
    }

    return (
      this.props.currentWorkOrder !== null && (
        <div className="details-quotes">
          {(PermissionsUtil.adminUserCanSeeMoney(this.props.currentUser) ||
            usersUtil.hasType(
              this.props.currentUser,
              TYPES.GENERAL_CONTRACTOR
            )) && (
            <React.Fragment>
              {!proposalOnWaiting &&
                this.showCreateProposalButton() &&
                !this.showCreateChangeOrderButton() && (
                  <div className="quotes-button-container">
                    <input
                      className="btn button button-orange"
                      type="button"
                      value="Create Proposal"
                      onClick={this.handleCreateProposalClick}
                    />
                  </div>
                )}
              {this.showCreateChangeOrderButton() && (
                <div className="quotes-button-container">
                  <input
                    className="btn button button-orange button-create-co"
                    type="button"
                    value="Create Change Order"
                    onClick={this.handleCreateChangeOrderClick}
                  />
                  <input
                    className="btn button button-gray"
                    type="button"
                    value="Move to ACR"
                    onClick={this.handleMoveToAcrClick}
                  />
                  <ConfirmationModal
                    show={this.state.showMoveToAcrConfirmation}
                    message="Are you sure you want to move these change orders to the ACR?"
                    onHide={this.handleMoveToAcrConfirmation}
                  />
                </div>
              )}

              {this.props.proposals.length > 0 && (
                <div className="proposals-admin">
                  <ProposalsTable
                    showHeader={false}
                    proposals={this.props.proposals}
                    proposalRenderer={(number) => {
                      return `Proposal ${number}`;
                    }}
                    onRowSelected={this.handleProposalSelection}
                    changeOrders={this.props.changeOrders}
                    approvedProposal={
                      this.props.currentWorkOrder.approved_proposal
                    }
                    changeOrderRenderer={(number) => {
                      return `Change Order ${number}`;
                    }}
                    onChangeOrderRowSelected={this.handleChangeOrderSelection}
                  />
                </div>
              )}

              <QuotesTable
                budgetTasksByTaskId={budgetTasksByTaskId}
                quoteTableRadios={this.props.quotesSelectedByTaskId}
                quotes={this.props.quotes.filter((element) => {
                  if (this.props.quotesTableSelectedFilter === 'all') {
                    return element;
                  } else {
                    return (
                      element.status === this.props.quotesTableSelectedFilter
                    );
                  }
                })}
                changeOrderTasks={this.props.changeOrderTasks}
                proposalSelectable={!proposalOnWaiting && !proposalOnApproved}
                changeOrderSelectable={!changeOrderOnWaiting}
                selectedFilter={this.props.quotesTableSelectedFilter}
                onFilterSelect={this.handleQuotesFilter}
                onRadioSelect={this.handleQuotesTableRadioSelect}
                onRowSelected={this.handleRowSelect}
                onChangeOrderRowSelected={this.handleChangeOrderRowSelect}
              />
            </React.Fragment>
          )}

          {this.userIsClient && this.props.proposals.length > 0 && (
            <React.Fragment>
              <div className="proposal-completion-date-container">
                <span className="body-regular">Target Completion Date</span>
                <span className="body-bold">
                  <Date
                    value={
                      this.props.proposals[this.props.proposals.length - 1]
                        .completion_date
                    }
                    format="M/D/YYYY"
                  />
                </span>
              </div>

              <div className="proposals-client">
                <ProposalsTable
                  showHeader={true}
                  proposals={this.props.proposals}
                  proposalRenderer={(number) => {
                    return <Number value={number} format="00" />;
                  }}
                  onRowSelected={this.handleProposalSelection}
                  changeOrders={this.props.changeOrders}
                  approvedProposal={
                    this.props.currentWorkOrder.approved_proposal
                  }
                  changeOrderRenderer={(number) => {
                    return (
                      <div>
                        Change Order <Number value={number} format="00" />
                      </div>
                    );
                  }}
                  onChangeOrderRowSelected={this.handleChangeOrderSelection}
                />
              </div>
            </React.Fragment>
          )}

          {this.props.showProposalShow && <ProposalModal />}
          {this.props.showChangeOrderModal && <ChangeOrderModal />}
          <QuoteDetailsModalContainer />
          <ChangeOrderQuoteDetailsModalContainer />
        </div>
      )
    );
  }

  showCreateProposalButton() {
    // Check that all tasks has one of the (received) quotes selected
    const openTasks = this.props.tasks.filter(
      (task) => task.status !== TaskStatusKeys.CLS
    );
    return (
      openTasks.length === Object.keys(this.props.quotesSelectedByTaskId).length
    );
  }

  showCreateChangeOrderButton() {
    return (
      this.props.proposals.filter((proposal) =>
        ProposalStatus.APPROVED.equals(proposal.status)
      ).length > 0 && Object.keys(this.props.quotesSelectedByTaskId).length > 0
    );
  }
}

export default connect((state) => {
  return {
    budget: getBudget(state),
    currentUser: getCurrentUser(state),
    currentWorkOrder: getCurrentWorkOrder(state),
    proposals: getProposals(state),
    quotes: getQuotes(state),
    quotesSelectedByTaskId: getQuotesSelectedByTaskId(state),
    quotesTableSelectedFilter: getQuotesTableSelectedFilter(state),
    showProposalShow: getProposalShow(state),
    tasks: getTasks(state),
    changeOrderTasks: getChangeOrderTasks(state),
    showChangeOrderModal: getShowChangeOrderModal(state),
    changeOrders: getChangeOrders(state),
  };
})(DetailsQuotes);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/DetailsQuotes.js